import { audioAlertSettings } from './AudioAlerts/alertDefaults';
import {
  ANALYTICS_IDENTITY,
  TALKROBIN_RESET,
  TALKROBIN_SET_USER,
} from '../constants/appEvents';
import AnalyticsHelper from './AnalyticsHelper';
import DashboardAudioNotificationHelper from './AudioAlerts/DashboardAudioNotificationHelper';
import { emitter } from 'shared/helpers/mitt';

export const initializeAnalyticsEvents = () => {
  AnalyticsHelper.init();
  emitter.on(ANALYTICS_IDENTITY, ({ user }) => {
    AnalyticsHelper.identify(user);
  });
};

export const initializeAudioAlerts = user => {
  const { ui_settings: uiSettings } = user || {};
  const {
    always_play_audio_alert: alwaysPlayAudioAlert,
    enable_audio_alerts: audioAlertType,
    alert_if_unread_assigned_conversation_exist: alertIfUnreadConversationExist,
    ring_until_opened: ringUntilOpened,
    notification_tone: audioAlertTone,
    // UI Settings can be undefined initially as we don't send the
    // entire payload for the user during the signup process.
  } = uiSettings || {};

  const defaults = audioAlertSettings(uiSettings || {});
  DashboardAudioNotificationHelper.set({
    currentUser: user,
    audioAlertType: audioAlertType || defaults.audioAlertType,
    audioAlertTone: audioAlertTone || 'ding',
    alwaysPlayAudioAlert: alwaysPlayAudioAlert || false,
    alertIfUnreadConversationExist: alertIfUnreadConversationExist || false,
    ringUntilOpened: ringUntilOpened ?? defaults.ringUntilOpened,
  });
};

export const initializeTalkrobinEvents = () => {
  emitter.on(TALKROBIN_RESET, () => {
    if (window.$talkrobin) {
      window.$talkrobin.reset();
    }
  });
  emitter.on(TALKROBIN_SET_USER, ({ user }) => {
    if (window.$talkrobin) {
      window.$talkrobin.setUser(user.email, {
        avatar_url: user.avatar_url,
        email: user.email,
        identifier_hash: user.hmac_identifier,
        name: user.name,
      });
      window.$talkrobin.setCustomAttributes({
        signedUpAt: user.created_at,
        cloudCustomer: 'true',
        account_id: user.account_id,
      });
    }

    initializeAudioAlerts(user);
  });
};
